module.exports = __webpack_public_path__ + "static/media/ekta_chopra.91cd01ff.png";